module.exports = __webpack_public_path__ + "static/media/Loading_Screen_Donut.963cfb1d.svg";